import {sweetAPI} from 'app/store/sweet-api';
import {showLoadingBar, showMessages} from 'app/store/sweet-api/utils';
import {VIDEO_API} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {VideoSerializedType} from 'sweet-types';

export const VIDEO_TAG = 'video';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [VIDEO_TAG]})
  .injectEndpoints({
    endpoints: (build) => ({
      video: build.query<VideoSerializedType, {hashid: string}>({
        query: (params = {hashid: ''}) => ({
          url: `${VIDEO_API}${params.hashid}/`,
        }),
        onQueryStarted: (args, api) => {
          showLoadingBar(args, api);
          showMessages({
            onError: () => gt('Unable to load video.'),
          })(args, api);
        },
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {useLazyVideoQuery: useLazyVideo} = extendedAPI;
